import { useQuery } from '@tanstack/vue-query'
import { healthCheck } from '@/api/keycloak_api'

/** Populate TanStack Query cache `['keycloakHealth']` for `redirectToLogin` gating. */
export function useKeycloakHealth() {
  useQuery({
    queryKey: ['keycloakHealth'],
    queryFn: healthCheck,
    staleTime: 30_000,
    retry: 2,
  })
}
